const FIELD = {
    CONTENT_TYPE: "Content-Type",
    AUTHORIZATION: "Authorization",
    API_VERSION: "api-version",
};

const CONTENT_TYPE_VALUES = {
    FORM_URL_ENCODED: "application/x-www-form-urlencoded;charset=UTF-8",
};

const AUTHORIZATION_VALUE = {
    BEARER: "bearer",
}

const HTTP_HEADER = {
    FIELD,
    CONTENT_TYPE_VALUES,
    AUTHORIZATION_VALUE,
};

export default HTTP_HEADER;